/**
 * What a siren played for one history point.
 *
 * A bulk-fetched point carries the command-history row's `command` and
 * `audio_name` (the /device/data queries join RI_Device_Command_History); a
 * live event point may carry only the relay strings the siren reported
 * (`PublicPA: 'Active'`, ...). Both shapes resolve here. The command numbers
 * mirror SIREN_COMMAND in the backend's simulatedTBStatus.ops.ts.
 */
const SIREN_COMMAND_LABELS = {
  1: 'Message (Public PA)',
  2: 'Standard Siren Tone',
  3: 'Flood Siren Tone',
  4: 'Flood Message (English)',
  5: 'Flood Message (Spanish)',
  6: 'Siren Test',
  7: 'Cancel Audio',
  8: 'Power Cycle',
};

const RELAY_TO_COMMAND = {
  PublicPA: 1,
  Sirentonemsg: 2,
  FloodSirenONLY: 3,
  FloodMessageENG: 4,
  FloodMessageESP: 5,
  Sirentest: 6,
  RescPowerCycle: 8,
};

/** The siren command a history point records, or null for an idle/plain point. */
export const resolveSirenCommand = (point) => {
  if (!point || typeof point !== 'object') return null;
  const command = Number(point.command ?? point.pCommand);
  if (Number.isFinite(command) && command > 0) return command;
  for (const [relay, relayCommand] of Object.entries(RELAY_TO_COMMAND)) {
    if (point[relay] === 'Active') return relayCommand;
  }
  if (point.CancelAudio === 'On') return 7;
  return null;
};

/**
 * Display label for the history's Tone column: the played file when the point
 * names one ("Custom Tone — x.mp3", "Message — y.mp3"), the standard label for
 * a file-less command, or an em dash for idle rows.
 */
export const describeSirenTone = (point) => {
  const command = resolveSirenCommand(point);
  if (command == null) return '—';
  const audioName = point?.audio_name || null;
  if (audioName) {
    if (command === 1) return `Message — ${audioName}`;
    if (command === 2) return `Custom Tone — ${audioName}`;
    return `${SIREN_COMMAND_LABELS[command] ?? `Command ${command}`} — ${audioName}`;
  }
  return SIREN_COMMAND_LABELS[command] ?? `Command ${command}`;
};
